import React from "react";
import $ from 'jquery';

export class NotFound extends React.Component {
    componentDidMount() {
        $('#spinner').addClass('hidden')
    }

    render() {
        return (
            <div className="d-flex flex-column mh-100vh align-items-center justify-content-center ">
                <h1 className="display-3" >404 page not found</h1>
                <p>OOPS, the page you are looking for doesn't exist.</p>
            </div>
        )
    }
}